import { render, staticRenderFns } from "./CurrentRate.vue?vue&type=template&id=ed2eaffe&scoped=true&"
import script from "./CurrentRate.vue?vue&type=script&lang=js&"
export * from "./CurrentRate.vue?vue&type=script&lang=js&"
import style0 from "./CurrentRate.vue?vue&type=style&index=0&id=ed2eaffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2eaffe",
  null
  
)

export default component.exports